import React from 'react';

export default () => {
    return (
        <div className={"content-block dx-card responsive-paddings"}>
            <div id="blazor-app">Carregando...</div>
        </div>
    );
};
